<script setup>
    import MainHeader from '@/components/HeaderComponent.vue';
    import { useRouter } from 'vue-router';
    import { useLoginStore } from '@/stores/login/loginStore';

    const router = useRouter();

    const loginStore = useLoginStore();

    function backToLogin() {
        router.push({ name: 'login', query: { vid: loginStore.vendorId } });
    }
</script>

<template>
    <section id="main" class="bg login extra">
        <MainHeader />
        <div id="contents" class="medium">
            <h2>{{ $t('signinUseridComplete.parts.pageTitle1') }}</h2>
            <h3 style="text-align: center; padding-top: 30px">{{ $t('signinUseridComplete.parts.pageInformation1') }}</h3>
            <h3 style="text-align: center; padding-top: 30px">{{ $t('signinUseridComplete.parts.pageInformation2') }}</h3>
            <ul class="btnArea">
                <li>
                    <button type="button" class="btnPrimary" @click="backToLogin">{{ $t('signinUseridComplete.parts.button1') }}</button>
                </li>
            </ul>
        </div>
    </section>
</template>

<style></style>
